"use client";
import { use, useState } from "react";
import { usePathname, useRouter } from "next/navigation";
import PlanListing from "./PlanListing";
import PrimaryButton from "@/Component/Common/Forms/PrimaryButton";

const AdminPlan = () => {
    const [planTab, setPlanTab] = useState('month');
    const router = useRouter();
    const togglePlanTab = () => {
        setPlanTab(planTab === 'month' ? 'year' : 'month');
    };

    const params = usePathname()
    const role = params.includes("brand") ? "brand" : "admin";

    const gotoCreatePlanPage = () => {
        router.push('/admin/plan/create-plan');
    };

    return (
        <div className="">
            <div className="flex items-center justify-center mb-2 gap-3">
                <span className="text-primary underline cursor-pointer text-sm" onClick={() => { gotoCreatePlanPage() }} >+ Add New Plan</span>
                {/* <PrimaryButton title="Add New Plan" buttonType="button" onClick={() => { }} /> */}
            </div>
            <div className="flex items-center justify-center mb-8 gap-3">
                <span className={`font-medium text-sm ${planTab === 'month' ? 'text-black' : 'text-gray/75'}`}>
                    Monthly
                </span>

                <label className="relative inline-flex items-center cursor-pointer">
                    <input
                        type="checkbox"
                        className="sr-only peer"
                        checked={planTab === 'year'}
                        onChange={togglePlanTab}
                    />
                    <div className="w-12 h-7 bg-white rounded-full relative border border-gray/50">
                        <div
                            className={`absolute top-[3px] left-[3px] w-5 h-5 bg-gradient-to-r from-primary  to-secondary rounded-full transition-transform duration-300 ${planTab === 'year' ? 'translate-x-5' : ''
                                }`}
                        ></div>
                    </div>
                </label>

                <span className={`font-medium text-sm ${planTab === 'year' ? 'text-black' : 'text-gray/75'}`}>
                    Yearly
                </span>
            </div>
            
            <div className="md:flex gap-10 justify-center">
                <PlanListing role={role} planTab={planTab} />
            </div>
        </div>
    )
};

export default AdminPlan;
